'use client';

import React from 'react';
import {useI18n} from '@udemy-v2/i18n';

import {HeroPill} from './hero-pill.react-component';
import {LogoSection} from './logo-section';
import {HeroCta} from './hero-cta';
import {PageForType} from '../../types/page';
import assetLoader from '@/utils/asset-loader';
import {SubscriptionPlan} from '@/generated/graphql';

import styles from './hero-section.module.scss';
import {ComponentLoader} from '../component-loader/component-loader';

// Text element component for consistent text rendering
const TextElement = ({text}: {text: string}) => {
    return <>{text}</>;
};

interface HeroSectionProps {
    pageFor?: PageForType | null;
    subscriptionPlans?: SubscriptionPlan[] | null;
    countryCode?: string | null;
}

function HeroSection({pageFor, subscriptionPlans, countryCode}: HeroSectionProps) {
    const {gettext} = useI18n();
    const firstGroup = gettext('Indeed is teaming up with Udemy to help you');
    const secondGroup = gettext('employers need so you can');
    const thirdGroup = gettext('of your dreams');

    return (
        <div className={styles.container}>
            <LogoSection />
            <section className={styles.headline}>
                <TextElement text={firstGroup} />
                <HeroPill
                    text={gettext('get the skills')}
                    imageSrc={[
                        {
                            source: assetLoader({
                                src: '/indeed/images/icons/pie-chart.png',
                            }),
                            className: 'pie-chart',
                        },
                        {
                            source: assetLoader({
                                src: '/indeed/images/icons/icon-ai.png',
                            }),
                            className: 'icon-ai',
                        },
                        {
                            source: assetLoader({
                                src: '/indeed/images/icons/keyboard.png',
                            }),
                            className: 'keyboard',
                        },
                    ]}
                    background="radial-gradient(152.91% 164.43% at -12.09% -20.69%, #2A2B3F 0%, #6D28D2 20.95%, #A435F0 67.37%, #A435F0 80%)"
                    hoverEffect="apart"
                    textColor="white"
                />

                <TextElement text={secondGroup} />
                <HeroPill
                    text={gettext('land the job')}
                    imageSrc={[
                        {
                            source: assetLoader({
                                src: '/indeed/images/icons/building.png',
                            }),
                            className: 'building',
                        },
                    ]}
                    background="#FFECDB"
                    hoverEffect="float"
                    textColor="black"
                />
                <TextElement text={thirdGroup} />
            </section>
            <ComponentLoader
                pageFor={pageFor}
                subscriptionPlans={subscriptionPlans}
                countryCode={countryCode}
                Component={HeroCta}
            />
        </div>
    );
}

export {HeroSection};
